import React, { Component } from 'react'
import StyleSheet from 'styles'
import { Dependent } from 'containers/shared/Dependent'
import { SectionLoader }    from '../../components/SectionLoader'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button'
import AddIcon from '@material-ui/icons/Add'
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Pagination from 'components/index_view/Pagination'
import { SortedTableHead } from 'components'

export const ResultsMixin = superclass => class extends superclass {

  constructor(props) {
    super(props)
    this.state = {
      ...this.state,
      currentPage: 1,
    }
  }

  handleOrderParamsChanged = (order) => {
    this.setState({order})
  }

  get orderParams(){
    return this.state.order
  }

  get title() {
    return 'Results'
  }

  get totalPages() {
    return this.data.totalPages || 1
  }

  get currentPage() {
    return this.state.currentPage
  }

  set currentPage(value) {
    this.setState({
      currentPage: value
    })
  }

  get data() {
    return this.props[this.resultsNameSpace] || {}
  }

  loadData = async(filter = this.filter, page = this.currentPage, pageSize = this.pageSize, order = this.orderParams, resultsNameSpace = this.resultsNameSpace) => {
    await this.actions.search({filter, page, pageSize, order, resultsNameSpace})
  }


  Table = ({emptyText = `No ${this.props.title || "Matching Items"}`, ...props}) => {
    if (this.data.results.length)
      return <Table {...props} />

    return <Typography className={styles.emptyListMsg}>{emptyText}</Typography>
  }

  TableHead = props =>
    <TableHead {...props} />

  SortedTableHead = props =>
    <SortedTableHead order={this.state.order} onOrderChange={this.handleOrderParamsChanged} {...props} />

  TableBody = props =>
    <TableBody {...props} />

  TableRow = props =>
    <TableRow {...props} />

  TableCell = ({type, ...props}) =>
    <TableCell {...props} className={`${this.props.className} ${styles.responsiveCell} ${type === 'numeric' ? styles.numericCell : ''} ${type === 'actions' ? styles.actionsCell : ''}`}/>

  List = ({children, itemCount = this.data.results.length, emptyText = `No ${this.props.title || "Matching Items"}`,
           wrapperProps, showAdd = this.props.showAdd, ...props}) => {

    if (showAdd === true)
      showAdd = 'bottom'

    return (
      <div className={showAdd === 'top' ? styles.listContainerAddOnTop : styles.listContainer} {...wrapperProps}>
        {showAdd === 'top' &&
          <Button variant='fab' color='primary' onClick={this.handleAddItem} className={styles.addOnTop}>
            <AddIcon/>
          </Button>
        }
        <List {...props}>
          {children}

          {!itemCount &&
          <Typography variant='subtitle1' className={styles.emptyListMsg}>{emptyText}</Typography>}

        </List>
        {showAdd === 'bottom' &&
          <Button variant='fab' color='primary' onClick={this.handleAddItem} className={styles.add}>
            <AddIcon/>
          </Button>
        }
      </div>
    )
  }

  ListItem = ({item, ...props}) =>
    <ListItem dense button={!!this.handleItemSelected} onClick={ () => { this.handleItemSelected && this.handleItemSelected(item) } } {...props} />

  ListItemText = props =>
    <ListItemText {...props}/>

  ResultsDependency = ((context) => class extends Component {
    dependsOn = () => context.dependsOn()
    dependenciesMet = () => context.dependenciesMet()
    render = () => context.renderResults(context.data.results)
  })(this)

  Results = props =>
    <Dependent component={this.ResultsDependency} options={{loader:SectionLoader, clearOnLoad:false, wrapperClassName: styles.wrapper}} {...props} />

  Pagination = props =>
    <div className={styles.pagination}>
      <Pagination totalPages={this.totalPages} page={this.currentPage} onPageSelected={(page) => this.currentPage = page} {...props} />
    </div>
}

export default ResultsMixin

const styles = StyleSheet({
  card: {
    width: '100%',
    height: '100%',
    position: 'relative'
  },
  content: {
    justifyContent: 'left',
    alignItems: 'left',
    display: 'flex',
    flexDirection: 'column'
  },
  listContainer: {
    position: 'relative',
    padding: '0px 0px 24px 0px'
  },
  listContainerAddOnTop: {
    position: 'relative',
    padding: '0px'
  },
  emptyListMsg: {
    paddingTop: '8px',
    paddingBottom: '8px',
    paddingLeft: '2px',
    paddingRight: '2px',
  },
  responsiveCell: {
    '@media(max-width: 1000px)': {
      padding: '5px !important',
      fontSize: '12px',
    },
    paddingRight: 34,
    whiteSpace: 'nowrap'
  },
  actionsCell: {
    paddingLeft: '8px !important'
  },
  numericCell: {
    textAlign: 'right'
  },
  add: {
    position: 'absolute !important',
    bottom: '-4px',
    right: '16px',
    zIndex: 100
  },
  addOnTop: {
    position: 'absolute !important',
    top: '-28px',
    right: '30px',
    zIndex: 100
  },
  pagination: {
    paddingTop: '5px',
    paddingBottom: '20px'
  },
})